import React, { memo, useCallback, useEffect, useState } from "react"
import { Drawer, DrawerBody, DrawerOverlay, DrawerContent } from "@chakra-ui/react"
import { Product, ProductVariant } from "@shopify/hydrogen-react/storefront-api-types"

import { useMedia } from "@app/hooks/useMedia"
import { ProductStockOverlayForm } from "./ProductStockOverlayForm"

type Props = {
  disableNoActiveOption: (state: boolean) => void
  handleBackInStock: () => void
  handleQuantity: (quantity: number) => void
  handleToggle: () => void
  isOpen: boolean
  isUnavailable: boolean
  loading: boolean
  noActiveOption: boolean
  parentProduct: Product
  product: Product
  quantity: number
  selectedVariant: ProductVariant
  setSelectedSiblingHandle: (handle: string) => void
  siblings: Array<any>
}

export const ProductStockOverlay: React.FC<Props> = memo(
  ({
    disableNoActiveOption,
    handleBackInStock,
    handleQuantity,
    handleToggle,
    isOpen,
    isUnavailable,
    loading,
    noActiveOption,
    parentProduct,
    product,
    quantity,
    selectedVariant,
    setSelectedSiblingHandle,
    siblings,
  }) => {
    const [activeStore, setActiveStore] = useState<string | null>(null)
    const [transition, setTransition] = useState<boolean>(false)
    const { isLarge } = useMedia()

    const handleActive = useCallback((id: string | null) => setActiveStore(prevState => (prevState === id ? null : id)), [setActiveStore])

    useEffect(() => {
      if (activeStore) setActiveStore(null)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    useEffect(() => {
      isOpen
        ? setTimeout(() => {
            setTransition(true)
          }, 500)
        : setTransition(false)
    }, [isOpen])

    return (
      <Drawer isOpen={isOpen} placement="right" size="lg" onClose={handleToggle}>
        <DrawerOverlay />
        <DrawerContent
          sx={{
            "&": {
              ...(isLarge && !!activeStore ? { maxW: "84rem !important" } : { maxW: { base: "100vw !important", lg: "42rem !important" } }),
              ...(transition ? { transition: "all 0.4s ease !important" } : {}),
            },
          }}
        >
          <DrawerBody bg="brand.white" p={0} overflow="hidden">
            <ProductStockOverlayForm
              key={product?.id}
              activeStore={activeStore}
              disableNoActiveOption={disableNoActiveOption}
              handleActive={handleActive}
              handleBackInStock={handleBackInStock}
              handleQuantity={handleQuantity}
              handleToggle={handleToggle}
              isUnavailable={isUnavailable}
              noActiveOption={noActiveOption}
              loading={loading}
              parentProduct={parentProduct}
              product={product}
              siblings={siblings}
              quantity={quantity}
              selectedVariant={selectedVariant}
              setSelectedSiblingHandle={setSelectedSiblingHandle}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    )
  }
)
